import { render } from "./ErrorLogs.vue?vue&type=template&id=32a16658&scoped=true"
import script from "./ErrorLogs.vue?vue&type=script&lang=js"
export * from "./ErrorLogs.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a16658"]])

export default __exports__